export default __webpack_public_path__ + "static/media/work-3left-2.21d5c9cd.png";